import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiChildContactInfoModule } from '../lib/shared-ui-child-contact-info.module'
import { ChildContactInfoDocsComponent } from './child-contact-info-docs/child-contact-info-docs.component'
import { ChildContactInfoExampleComponent } from './child-contact-info-docs/child-contact-info-example.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiChildContactInfoModule
  ],
  declarations: [
    ChildContactInfoDocsComponent,
    ChildContactInfoExampleComponent
  ],
  exports: [
    ChildContactInfoDocsComponent
  ]
})
export class SharedUiChildContactInfoDocsModule {}
